import { enumPropsFactoryProvider, objectToEnumMap } from './enum-helper';

/**
 * Стили текста текста
 * @type {Object}
 */
export var TEXT_STYLE = {
    button: 'button',
    numbersL: 'numbers_l',
    numbersM: 'numbers_m',
    numbersS: 'numbers_s',
    numbersXS: 'numbers_xs',
    titleL: 'title_l',
    titleM: 'title_m',
    titleS: 'title_s',
    titleXS: 'title_xs',
    textM: 'text_m',
    textMMedium: 'text_m_medium',
    textSMedium: 'text_s_medium',
    textMGrey: 'text_m_grey',
    textSGrey: 'text_s_grey',
    textS: 'text_s',
    textXS: 'text_xs',
    textXXS: 'text_xxs',
    cardHeader: 'card_header'
};

export var AVAILABLE_TEXT_STYLE = objectToEnumMap(TEXT_STYLE);

/**
 * Полчить стиль с размером шрифта меньше чем @style
 * @param {String} style
 * @return {String}
 */
export var getStyleSmallerThan = function getStyleSmallerThan(style) {
    switch (style) {
        case TEXT_STYLE.numbersL:
            return TEXT_STYLE.numbersM;
        case TEXT_STYLE.numbersM:
            return TEXT_STYLE.numbersS;
        case TEXT_STYLE.numbersS:
            return TEXT_STYLE.numbersXS;
        case TEXT_STYLE.titleL:
            return TEXT_STYLE.titleM;
        case TEXT_STYLE.titleM:
            return TEXT_STYLE.titleS;
        case TEXT_STYLE.titleS:
            return TEXT_STYLE.titleXS;
        case TEXT_STYLE.textM:
            return TEXT_STYLE.textS;
        case TEXT_STYLE.textS:
            return TEXT_STYLE.textXS;
        case TEXT_STYLE.textXS:
            return TEXT_STYLE.textXXS;
        case TEXT_STYLE.textMMedium:
            return TEXT_STYLE.textSMedium;
        case TEXT_STYLE.textMGrey:
            return TEXT_STYLE.textSGrey;
        default:
            return style;
    }
};

/**
 * Парсера параметра text_style
 * @see https://github.yandex-team.ru/portal/morda-schema/blob/master/api/search/2/div/div-text-style.json
 * @param  {String} textStyle
 * @param  {String} defaulTextStyle
 * @return {String}
 */
export default enumPropsFactoryProvider(AVAILABLE_TEXT_STYLE, TEXT_STYLE.textM);